import React from 'react'
import { createPortal } from 'react-dom'
import s from './styles/Modal.module.scss'
import { useModal } from './hooks/useModal'
import Button from '../Button/Button'

const Modal = ({
	isOpen,
	onClose,
	title,
	iconTitle: IconTitle,
	subtitle,
	steps,
	stepIndex = 0,
	bodySubtitle,
	children,
	footerButtons = [],
	width = 568,
	maxHeight = 648,
	compact = false,
	closeButtonClassName = '',
	closeOnBackdrop = true,
	closeOnEsc = true,
	initialFocusRef,
	ariaLabel = 'Modal',
}) => {
	const { modalRef, onBackdropMouseDown, sizeStyle } = useModal({
		isOpen,
		onClose,
		closeOnBackdrop,
		closeOnEsc,
		initialFocusRef,
		width,
		maxHeight,
	})

	if (!isOpen) return null

	return createPortal(
		<div
			className={s.overlay}
			role="dialog"
			aria-modal="true"
			aria-label={ariaLabel}
		>
			<div className={s.backdrop} onMouseDown={onBackdropMouseDown} />

			<div ref={modalRef} className={`${s.modal} ${compact ? s.compact : ''}`.trim()} style={sizeStyle}>
				<div className={s.header}>
					<div className={s.header__inner}>
						{(title || IconTitle) && (
							<div className={s.title}>
								{IconTitle && (
									<span className={s.title__icon}>
										<IconTitle />
									</span>
								)}
								{title && <span className={s.title__text}>{title}</span>}
							</div>
						)}
						{subtitle && <div className={s.subtitle}>{subtitle}</div>}
					</div>

					<button
						type="button"
						className={`${s.closeBtn} ${closeButtonClassName}`.trim()}
						onClick={onClose}
						aria-label="Close"
					>
						✕
					</button>
				</div>

				{Array.isArray(steps) && steps.length > 0 && (
					<div className={s.stepper}>
						{steps.map((st, idx) => {
							const isActive = idx === stepIndex
							const isDone = idx < stepIndex

							return (
								<div
									key={st.id}
									className={`${s.step} ${isActive ? s.active : ''} ${
										isDone ? s.done : ''
									}`.trim()}
								>
									<div className={s.stepLine} />
									<div className={s.stepLabel}>{st.label}</div>
								</div>
							)
						})}
					</div>
				)}

				<div className={s.body}>
					{bodySubtitle ? (
						<span className={s.bodySubtitle}>{bodySubtitle}</span>
					) : null}
					{children}
				</div>

				{!!footerButtons?.length ? (
					<div className={s.footer}>
						{footerButtons.map(btn => (
							<Button
								key={btn?.id || btn?.text}
								onClick={btn?.onClick}
								variant={btn?.variant}
								className={s.btn}
							>
								{btn.text}
							</Button>
						))}
					</div>
				) : null}
			</div>
		</div>,
		document.body
	)
}

export default Modal
